import { render } from "./QuillEditor.vue?vue&type=template&id=13585f6d&scoped=true"
import script from "./QuillEditor.vue?vue&type=script&lang=js"
export * from "./QuillEditor.vue?vue&type=script&lang=js"

import "./QuillEditor.vue?vue&type=style&index=0&id=13585f6d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13585f6d"]])

export default __exports__